import React from 'react';

const PropertyInformationIcon = React.memo(({color,...props}) => <svg width="22" height="22" viewBox="0 0 22 22" fill="none" {...props}>
    <path d="M13 7H21V21H13M13 21V1H1V21H13ZM5 15H9V21H5V15Z" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
</svg>)

export default PropertyInformationIcon;

PropertyInformationIcon.defaultProps = {
    color:'#212121'
};